import { fn } from '@ember/helper';
import { action } from '@ember/object';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import $ from 'jquery';

import { equal } from 'webapp/utils/common';

import didUpdate from 'webapp/modifiers/did-update';
import FormInputComponent from 'webapp/components/form/input';

interface Args {
	length: number;
	value: string;
	onChange: (val: string) => void;
}

interface FormMultiInputComponentInterface<T> {
	Element: HTMLInputElement | HTMLTextAreaElement; // this is needed for ...attributes
	Args: T;
}

export default class FormMultiInputComponent extends Component<
	FormMultiInputComponentInterface<Args>
> {
	@tracked valueArray: string[] = [];

	constructor(owner: Owner, args: Args) {
		super(owner, args);
		this.updateValueArray(true);
	}

	@action
	updateValueArray(isInitialCheck = false): void {
		const valueArray = Array<string>(this.args.length).fill('');
		this.args.value.split('').forEach((v: string, k: number) => {
			valueArray[k] = v;
		});
		if (isInitialCheck === true || !equal(valueArray, this.valueArray)) {
			this.valueArray = valueArray;
		}
	}

	@action
	updateChar(index: number, e: KeyboardEvent): void {
		const el = $(e.target as HTMLInputElement),
			valueArray = this.valueArray,
			valueArrayPrev = Array.from(valueArray),
			prevChar = valueArray[index],
			char = String(el.val() || ''),
			pressedKey = e.key;

		let goForward = false,
			goBack = false;

		if (e.key.length === 1) {
			// not chars: Backspace, Shift, Meta etc.

			valueArray[index] = pressedKey;

			// we want to overwrite current value when char pressed even if input size is 1 (which means prevChar === char)
			el.val(pressedKey);

			goForward = true;
		} else {
			valueArray[index] = char;

			switch (pressedKey) {
				case 'Left':
				case 'ArrowLeft':
					goBack = true;
					break;
				case 'Right':
				case 'ArrowRight':
					goForward = true;
					break;
				case 'Backspace':
					// on delete itself, stay in input, second backspace (when no prevChar) should move us back
					if (!prevChar) {
						goBack = true;
					}
					break;
			}
		}

		if (goForward) {
			el.next('input').focus();
		} else if (goBack) {
			el.prev('input').focus();
		}

		if (!equal(valueArrayPrev, valueArray)) {
			this.args.onChange(valueArray.join(''));
		}
	}
	<template>
		<div class="multi-input" {{didUpdate (fn this.updateValueArray false) @length @value}}>
			{{#each this.valueArray as |char index|}}
				<FormInputComponent
					maxlength="1"
					...attributes
					@value={{char}}
					{{! @glint-ignore: the method bind }}
					onkeyup={{fn this.updateChar index}}
				/>
			{{/each}}
		</div>
	</template>
}
